<template>
  <v-app>
    <Appbar/>
    <v-main>
      <Information/>
      <router-view/>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
import Footer from '../component/Footer.vue';
import Appbar from '../component/Appbar.vue';
import Information from '../component/Information.vue';

export default {
  name: "Novels",
  components: {
    Footer,
    Appbar,
    Information
  },


}
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
